__turbopack_context__.v({
  "questionnaireNavigation": "QuestionnaireNavigation-module__S9hHqq__questionnaireNavigation",
  "questionnaireNavigationContainer": "QuestionnaireNavigation-module__S9hHqq__questionnaireNavigationContainer",
  "questionnaireNavigationCount": "QuestionnaireNavigation-module__S9hHqq__questionnaireNavigationCount",
  "questionnaireNavigationHeaderNormal": "QuestionnaireNavigation-module__S9hHqq__questionnaireNavigationHeaderNormal",
  "questionnaireNavigationHeaderSmall": "QuestionnaireNavigation-module__S9hHqq__questionnaireNavigationHeaderSmall",
});
